import { useCallback } from "react";
import { useMap } from "maplibre-react-components";
import type { Map as MapLibreMap } from "maplibre-gl";

interface MoveOptions {
  zoom?: number;
  animate?: boolean;
  duration?: number;
}

export function useMoveTo() {
  const map = useMap() as MapLibreMap | null;

  return useCallback(
    (lng: number, lat: number, opts: MoveOptions = {}) => {
      if (!map) return;

      const { zoom = map.getZoom(), animate = true, duration = 1000 } = opts;
      const center: [number, number] = [lng, lat];

      if (animate && map.flyTo) {
        map.flyTo({ center, zoom, duration, essential: true });
      } else {
        map.jumpTo({ center, zoom });
      }
    },
    [map]
  );
}
